import React from "react";

const App = ({ children }) => {
  return (
    <div className="w-full h-screen items-center justify-center">
      {children}
    </div>
  );
};

export default App;
